<template>
  <div class="sales_goods">
    <div class="relative">
      <el-tabs
        class="modify-el__tabs"
        v-model="activeName"
        @tab-click="handleClick"
      >
        <el-tab-pane
          v-for="item in panel"
          :label="item.label"
          :name="item.name"
          :key="item.name"
          lazy
        >
          <SearchComponent
            :condition="
              item.name === '1'
                ? inSalesGoods.condition
                : soldOutGoods.condition
            "
            :type="item.type"
            ref="search"
            @updateData="_updateData"
          />
          <TableComponent
            ref="table"
            :tableData="
              item.name === '1'
                ? inSalesGoods.tableData
                : soldOutGoods.tableData
            "
            :pagination="
              item.name === '1'
                ? inSalesGoods.pagination
                : soldOutGoods.pagination
            "
            :type="item.type"
            :params="{
              del: 'revoke',
              goodsDownOperator: 'forsales'
            }"
            @updateData="_updateData"
            @openPop="_openPop"
          />
        </el-tab-pane>
      </el-tabs>
      <AreaTemplate
        @updateData="_updateData"
        :dialogVisible.sync="areaVisible"
        :tableData="tableData"
        :pagination="pagination"
        :params="addParams"
      />
    </div>
  </div>
</template>

<script>
import TableComponent from '../Components/SalesGoodsComponent/TableComponent/'
import SearchComponent from '../Components/SalesGoodsComponent/SearchComponent/'
import AreaTemplate from '../Components/SalesGoodsComponent/AreaTemplate'
import tabsIndex from 'mixins/tabsIndex'
import updateData from 'mixins/updateData'

export default {
  name: 'inSalesGoods',
  inheritAttrs: false,
  mixins: [tabsIndex, updateData],
  components: {
    TableComponent,
    SearchComponent,
    AreaTemplate
  },
  data() {
    this.keyMap = {
      goods_list: {
        name: 'tableData',
        goods_id: 'id',
        authorized_id: 'authorizedId',
        goods_image: 'img',
        goods_en: 'enName',
        goods_name: 'cnName',
        add_time: 'time',
        sales_price: 'salesPrice',
        goods_sku: 'sku',
        goods_url: 'appletsUrl',
        goods_storage: 'stock',
        goods_state: 'state',
        sales_number: 'salesVolume',
        qr_code: 'qrImg',
        goods_verify: 'status',
        transport_id: 'transportId',
        sales_area_id: 'salesAreaId',
        spec_list: 'salesSize',
        sales_id: 'salesId',
        sales_quantity: 'salesNumber',
        goods_price: 'goodsPrice',
        authorized_start_price: 'startPrice',
        authorized_end_price: 'endPrice',
        goods_merchant_id: 'goodsMerchantId',
        merchant_id: 'merchantId',
        goods_type: 'goodsType',
        spec_id: 'specId',
        is_combination: 'isCombination'
      },
      sales_area_list: {
        name: 'tableData',
        sales_area_id: 'id',
        sales_title: 'templateName',
        area_name: 'area'
      },
      transport_list: {
        name: 'tableData',
        area_name: 'area',
        continuation: 'moreItem',
        continuation_cost: 'addShipping',
        first_cost: 'shipping',
        first_piece: 'firstItem',
        transport_id: 'id',
        transport_title: 'templateName'
      }
    }
    this.key = ['inSalesGoods', 'soldOutGoods']
    this.panel = [
      {
        label: '在售中商品',
        name: '1',
        type: 'inSalesGoods'
      },
      {
        label: '已售完商品',
        name: '2',
        type: 'soldOutGoods'
      }
    ]
    this.salesAreaTemplate = []
    this.transportAreaTemplate = []
    return {
      activeName: '1',
      inSalesGoods: {
        condition: {
          name: '',
          sku: '',
          price: '',
          priced: '',
          orderAttribution: '',
          platformId: '',
          goodsCategoray: '',
          vipLevel: '',
          storeCategoray: '',
          status: '',
          time: '',
          appletsId: ''
        },
        tableData: [],
        pagination: {}
      },
      soldOutGoods: {
        condition: {
          name: '',
          sku: '',
          price: '',
          priced: '',
          orderAttribution: '',
          platformId: '',
          goodsCategoray: '',
          vipLevel: '',
          storeCategoray: '',
          status: '',
          time: '',
          appletsId: ''
        },
        tableData: [],
        pagination: {}
      },
      dialogVisible: false,
      tableData: [],
      pagination: {},
      addParams: {}
    }
  },
  created() {
    this.search_model = ['on_sale', 'sold_out']
    this._getGoodsList(
      {
        curpage: 1,
        search_model: this.search_model[+this.activeName - 1]
      },
      'inSalesGoods'
    )
    this._getTransportList({ curpage: 1 })
    this._getSalesAreaList({ curpage: 1 })
  },
  computed: {
    areaVisible: {
      get() {
        return this.dialogVisible
      },
      set(val) {
        this.dialogVisible = val
      }
    }
  },
  methods: {
    /**
     * 标签页切换
     * @param tab
     * @param event
     */
    handleClick(tab, event) {
      const type = this.key[+this.activeName - 1]
      const params = this._switchParamsType(this.activeName, 1)
      this[type].pagination.currentPage = 1
      this._getGoodsList(params, type)
      this._tabsRecord()
    },
    /**
     * 获取内容
     * @param params
     * @param type
     * @private
     */
    _getGoodsList(params, type) {
      this.api.getGoodsList(params).then(res => {
        this.utils.setCommonCode(res, this, type)
      })
    },
    /**
     * 传参
     * @param index
     * @param newVal
     * @private
     */
    _switchParamsType(index, newVal) {
      switch (index) {
        case '1':
          return {
            curpage: newVal,
            search_model: 'on_sale'
          }
        case '2':
          return {
            curpage: newVal,
            search_model: 'sold_out'
          }
      }
    },
    /**
     * 获取运费模板列表
     * @param params
     * @private
     */
    _getTransportList(params) {
      this.api.getTransportList(params).then(res => {
        this.utils._modifyObjKey(res, this.keyMap)
        this.transportAreaTemplate = this.tableData = res.tableData
        this.pagination.pageTotal = +res.page_count
        this.pagination.recordTotal = +res.total_number
      })
    },
    /**
     * 获取销售区域模板列表
     * @param params
     * @private
     */
    _getSalesAreaList(params) {
      this.api.getSalesAreaList(params).then(res => {
        this.utils._modifyObjKey(res, this.keyMap)
        this.salesAreaTemplate = this.tableData = res.tableData
        this.pagination.pageTotal = +res.page_count
        this.pagination.recordTotal = +res.total_number
      })
    },
    /**
     * 打开弹窗更改内容
     * @param rows
     * @param type
     * @private
     */
    _openPop(rows, type) {
      this.dialogVisible = true
      switch (type) {
        case 'salesArea':
          this.tableData = this.salesAreaTemplate
          this.addParams = {
            templateName: '销售模板名称',
            areaName: '销售区域',
            type: 'sale',
            radioId: rows.salesAreaId,
            goodsMerchantId: rows.goodsMerchantId,
            goodsId: rows.id
          }
          break
        case 'transportTemplate':
          this.tableData = this.transportAreaTemplate
          this.addParams = {
            templateName: '运费模板名称',
            areaName: '运费区域',
            type: 'freight',
            radioId: rows.transportId,
            firstItemName: '首件运费',
            moreItemName: '续件运费',
            goodsMerchantId: rows.goodsMerchantId,
            goodsId: rows.id,
            width: '86rem'
          }
          break
      }
    },
    /**
     * 刷新页面数据
     * @private
     */
    _refreshPage() {
      const type = this.key[+this.activeName - 1]
      let data = this._switchParamsType(
        this.activeName,
        this[type].pagination.currentPage
      )
      this._getGoodsList(data, type)
    }
  }
}
</script>
